var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nested-select-field',{attrs:{"label":_vm.label,"items":_vm.structure.type.values,"error-messages":_vm.errorMessages || [],"multiple":"","outlined":"","clearable":""},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }